<script setup lang="ts">
import { useStore } from "@/utils/useStore";
import { computed, ref, watch } from "vue";
import { ImportingService } from "../utils/processors/mutua";
import ImportForm from "./ImportForm.vue";
import ImportedServiceCard from "./ImportedServiceCard.vue";

// This is just to add it on the services key and prevent old data to remain on them
const ts = ref(new Date().getTime());

const store = useStore();

const visible = computed(() => store.getters["app/importServicesDrawer"]);

const size = ref("500px");

const services = ref<ImportingService[]>([]);

const handlePreview = (importedServices: ImportingService[]) => {
  ts.value = new Date().getTime();
  services.value = importedServices;
  size.value = "90%";
};

const handleCancel = () => {
  services.value = [];
  size.value = "500px";
};

const handleCreate = () => {
  console.log(services.value);
};

const close = () => {
  store.dispatch("app/setImportServicesDrawer", false);
};

const groupedServices = computed<{ [key: string]: ImportingService[] }>(() => {
  return Object.fromEntries(
    Object.entries(
      services.value.reduce(
        (acc, service) => {
          acc[service.id] = acc[service.id] || [];
          acc[service.id].push(service);
          return acc;
        },
        {} as Record<string, ImportingService[]>
      )
    ).map(([id, services]) => {
      return [id, services.sort((a, b) => a.step - b.step)];
    })
  );
});

const setValid = (key: string, value: boolean) => {
  valid.value = {
    ...valid.value,
    [key]: value,
  };
};

const allValid = ref(false);
const valid = ref<{ [key: string]: boolean }>(
  Object.values(groupedServices.value).reduce((acc: { [key: string]: boolean }, _services) => {
    acc[_services[0].id] = false;
    return acc;
  }, {})
);

watch(
  valid,
  () => {
    allValid.value = Object.values(valid.value).filter((v) => v === false).length === 0;
  },
  { deep: true }
);
</script>

<template>
  <el-drawer
    :visible="visible"
    title="Importar servicios"
    :size="size"
    :close-on-press-escape="false"
    :wrapper-closable="false"
    @close="close"
  >
    <div class="drawer-content">
      <ImportForm v-if="services.length === 0" @preview="handlePreview" />
      <div v-else>
        <div class="imported-services">
          <ImportedServiceCard
            v-for="services in groupedServices"
            :key="`${ts}_${services[0].id}`"
            :services="services"
            style="margin-bottom: 15px"
            @validationChange="setValid(services[0].id, $event)"
          />
        </div>
        <div class="footer-actions">
          <el-button type="danger" size="mini" @click="handleCancel">Cancelar</el-button>
          <el-button
            :disabled="!allValid"
            type="primary"
            size="mini"
            class="ml-auto"
            @click="handleCreate"
          >
            Crear servicios
          </el-button>
        </div>
      </div>
    </div>
  </el-drawer>
</template>

<style scoped>
::v-deep .el-drawer {
  transition: width 0.3s ease-in-out;
}

.imported-services {
  gap: 15px;
  overflow-y: auto;
  height: calc(100vh - 130px);
}

.footer-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 15px;
  position: absolute;
  width: 100%;
  left: 0;
  bottom: 0;
  padding: 20px;
}
</style>
